import * as React from "react";
const SvgFixedSize = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 5H5V19H19V5ZM3 3V21H21V3H3Z", fill: "currentColor" }));
export default SvgFixedSize;
